import React, { useState, useEffect } from "react";

import Contentcomments from "../../components/Comments/content_comments";
import Spinner from "../../components/Spinner/spinner";
import "../../assets/css/styles.css";
import "../../assets/libs/bootstrap/css/bootstrap.min.css";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import api from "../../api";
const Comments = () => {
  const [loading, setLoading] = useState(true);
  const [showSpinner, setShowSpinner] = useState(false);
  const [dataComment, setDataComment] = useState([]);
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const handleAddNewComment = (obj) => {
    console.log(obj);
    setDataComment((prev) => [...prev, obj]);
  };
  const navigate = useNavigate();
  useEffect(() => {
    const token = localStorage.getItem(`${process.env.REACT_APP_LOCAL_TOKEN}`);
    const token_horoscope = localStorage.getItem(
      `${process.env.REACT_APP_LOCAL_TOKEN_HOROSCOPE}`,
    );
    if (!token && !token_horoscope) {
      navigate("/signin", { replace: true });
    }
  }, []);

  return (
    <>
      {showSpinner ? (
        <Spinner />
      ) : (
        <Contentcomments
          dataComment={dataComment}
          handleAddNewComment={handleAddNewComment}
        />
      )}
    </>
  );
};

export default Comments;
